import { Controller } from "@hotwired/stimulus"

// The impersonation bar folds to a badge and stays folded across pages, as
// remembered in this browser. Storage may be unavailable (private windows);
// the bar then simply starts open.
const KEY = "impersonation-bar:folded"

export default class extends Controller {
  static targets = ["badge", "panel"]
  static classes = ["open"]

  connect() {
    this.#show(!this.#folded())
  }

  open() {
    this.#remember(false)
    this.#show(true)
    this.panelTarget.querySelector("button, [href]")?.focus()
  }

  close() {
    this.#remember(true)
    this.#show(false)
    this.badgeTarget.focus()
  }

  #show(open) {
    this.element.classList.toggle(this.openClass, open)
    this.panelTarget.inert = !open
    this.badgeTarget.inert = open
  }

  #folded() {
    try { return window.localStorage.getItem(KEY) === "1" } catch { return false }
  }

  #remember(folded) {
    try { window.localStorage.setItem(KEY, folded ? "1" : "0") } catch { /* not kept */ }
  }
}
